import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types";

export const getMembershipEventsIsPending = (state: RootState) => state.domains.membershipEvents.isPending;

export const getMembershipEventsById = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.domains.membershipEvents.data[id];

export const getMembershipEventsIds = (state: RootState) => state.domains.membershipEvents.ids;

export const createMembershipEventsSelector = (ids: string[]) =>
  createSelector(
    ...ids.map((id) => (state: RootState) => state.domains.membershipEvents.data[id]),
    (...membershipEvents) => membershipEvents,
  );
